module.exports = __webpack_public_path__ + "img/background.8cb8adb9.jpg";